import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * DarkModeToggle Component
 * Circular button that toggles between videogame (light) and cyberpunk (dark) themes
 */
export function DarkModeToggle() {
  const { theme, setTheme } = useTheme();

  // Dark mode is cyberpunk theme
  const isDark = theme === 'cyberpunk';

  const toggleDarkMode = () => {
    setTheme(isDark ? 'videogame' : 'cyberpunk');
  };

  return (
    <button
      type="button"
      onClick={toggleDarkMode}
      className="neo-icon-btn relative flex items-center justify-center rounded-full"
      style={{
        width: '48px',
        height: '48px',
        backgroundColor: 'var(--theme-surface)',
        color: 'var(--theme-text)',
      }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light Mode' : 'Dark Mode'}
    >
      {isDark ? (
        <Sun className="h-6 w-6" />
      ) : (
        <Moon className="h-6 w-6" />
      )}
    </button>
  );
}
